// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2S2_r","notes":"Notes_notes__1p-g5"};